import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fn-filters-modal',
  templateUrl: './fn-filters-modal.component.html',
  styleUrls: ['./fn-filters-modal.component.scss'],
})
export class FnFiltersModalComponent implements OnInit {
  datesForm!: FormGroup;
  maxDate!: string;
  minEndDate?: string;
  searchValue?: string;
  @Output() filtersApplied = new EventEmitter<any>();

  get startDate() {
    return this.datesForm.get('startDate');
  }

  get endDate() {
    return this.datesForm.get('endDate');
  }

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<FnFiltersModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      optionalTitle: string;
      executeService: any;
      hideSearchBox: boolean;
      startDate?: string;
      endDate?: string;
      searchValue?: string;
    }
  ) {}

  ngOnInit(): void {
    this.datesForm = this.fb.group({
      startDate: [this.data.startDate ? this.data.startDate : ''],
      endDate: [this.data.endDate ? this.data.endDate : ''],
      searchValue: [this.data.searchValue ? this.data.searchValue : ''],
    });
  }

  openCalendar(DateInput: HTMLInputElement): void {
    setTimeout(() => {
      console.log('cloi');
      DateInput.click();
    }, 100);
  }

  onStartDateChange() {
    if (this.startDate?.value) {
      const startDate = new Date(this.startDate.value);
      this.minEndDate = startDate.toISOString().split('T')[0];
    } else {
      this.minEndDate = undefined;
    }
  }

  applyFilters() {
    const filters = this.datesForm.value;
    console.log('Filters', filters);
    this.data.executeService;
    this.filtersApplied.emit(this.datesForm.value);
    this.dialogRef.close(this.datesForm.value);
  }
}
